/* eslint-disable camelcase */
// TODO: 環境の接続先をここで管理しているため注意
export const RUNNING_TYPE: string = 'master'; // master,develop,local,tester
export const RUNNING_TYPE_MASTER: string = 'master';
export const RUNNING_TYPE_DEVELOP: string = 'develop';
export const RUNNING_TYPE_LOCAL: string = 'local';
export const RUNNING_TYPE_TESTER: string = 'tester';

export const TESTER_LOGIN_ID: string = 'tester@rc.com';
export const TESTER_LOGIN_PASSWORD: string = 'tester';

// 本番環境
export const API_URL = 'https://bosai-cloud-4-fk.com';
export const LOGIN_API_URL = 'https://bosai-cloud-4-fk.com/api/v1/login';
export const PUSH_SEND_API_URL =
  'https://bosai-cloud-4-fk.com/api/v1/push/send';
export const PUSH_LOG_API_URL = 'https://bosai-cloud-4-fk.com/api/v1/push/log';
export const DELETE_LOG_API_URL =
  'https://bosai-cloud-4-fk.com/api/v1/hidden/log';
export const GET_MUNICIPALITY_URL =
  'https://s3.ap-northeast-1.amazonaws.com/prod.rcsc.co.jp/fukuoka/municipalities_exmaple.json';
// 検証環境
export const API_DEV_URL = 'http://153.127.216.108';
export const LOGIN_API_DEV_URL = 'http://153.127.216.108/api/v1/login';
export const PUSH_SEND_API_DEV_URL = 'http://153.127.216.108/api/v1/push/send';
export const PUSH_LOG_API_DEV_URL = 'http://153.127.216.108/api/v1/push/log';
export const DELETE_LOG_API_DEV_URL = `http://153.127.216.108/api/v1/hidden/log`;
// ローカル
export const API_LOCAL_URL = 'http://localhost:8080';
export const LOGIN_API_LOCAL_URL = 'http://localhost:8080/api/v1/login';
export const PUSH_SEND_API_LOCAL_URL = 'http://localhost:8080/api/v1/push/send';
export const PUSH_LOG_API_LOCAL_URL = 'http://localhost:8080/api/v1/push/log';
export const DELETE_LOG_API_LOCAL_URL =
  'http://localhost:8080/api/v1/hidden/log';
// API
export const FILE_LIST_API = '/api/v1/file/list';
export const FILE_UPLOAD_API = '/api/v1/file/upload';
export const FILE_DELETE_API = '/api/v1/file/delete';
// s3
export const PUSH_LOG_API_S3_URL =
  'https://s3.ap-northeast-1.amazonaws.com/prod.rcsc.co.jp/fukuoka/notification_history.json';
export const FILE_LIST_API_S3_URL =
  'https://s3.ap-northeast-1.amazonaws.com/prod.rcsc.co.jp/fukuoka/file_list.json';
// APIキー
export const API_KEY =
  'CB851DD310A8C322C2765EF7248E0326AA28DB98E594D65FB42B1C5814F4D7CB';
export const API_KEY_RC_TEST =
  'CB851DD310A8C322C2765EF7248E0326AA28DB98E594D65FB42B1C5814F4D7CB';
// error_code
export const ERROR_CODE_15 = 'invalid_login_id';
export const ERROR_CODE_16 = 'invalid_login_password';
// login時エラーメッセージ
export const ERROR_MESSAGE_WRONG_LOGIN = 'IDまたはパスワードが誤っています。';
export const ERROR_MESSAGE_ID_LOGIN = 'IDが誤っています。';
export const ERROR_MESSAGE_PASSWORD_LOGIN = 'パスワードが誤っています。';
export const ERROR_MESSAGE_LOGIN = 'ログインに失敗しました。';
// APIエラー時のメッセージ
export const ERROR_MESSAGE_API =
  'エラーが発生しました。時間をおいてもう一度お試しください';

// #region
export const MENU_PUSH_SEND_TEXT = '通知';
export const MENU_PUSH_LOG_TEXT = '履歴';
export const MENU_FILE_LIST_TEXT = 'ファイル一覧';
export const MENU_PUSH_FORM_TEXT = 'GoogleForm';
export const MENU_PUSH_FORM_URL = 'https://docs.google.com/forms/';

export const TITLE_TEXT = 'タイトル';
export const MESSAGE_TEXT = 'メッセージ';
export const ADDITIONAL_TEXT = '付加情報';
export const ADDITIONAL_KEY_TEXT = 'Key';
export const ADDITIONAL_VALUE_TEXT = 'Value';
export const PARAMETER_TEXT = 'その他';

export const DEVICE_TYPE_TEXT = 'デバイスタイプ';
export const DEVICE_TYPE_ALL_TEXT = 'すべて';
export const DEVICE_TYPE_ANDROID_TEXT = 'Android';
export const DEVICE_TYPE_IOS_TEXT = 'iOS';
export const DEVICE_TYPE_ANDROID_CODE = 'android';
export const DEVICE_TYPE_IOS_CODE = 'ios';

export const LOCATION_SELECT_PREFECTURE_TEXT = '都道府県で絞り込み';
export const LOCATION_SELECT_CITY_TEXT = '市区町村で絞り込み';
export const LOCATION_SELECT_VILLAGE_TEXT = '村域以下で絞り込み';
export const LOCATION_SELECT_UNCHECK_TEXT = '全てのチェックをはずす';
export const LOCATION_ALL_SELECTED_TEXT = '福岡県全域';
export const LOCATION_NOT_SELECTED_TEXT = 'なし';
export const LOCATION_SELECT_DEFAULT_TEXT = '選択してください';
export const LOCATION_ALL_TEXT = 'すべて';
export const LOCATION_OVERSEAS_TEXT = '海外';
export const LOCATION_UNDEFINED_TEXT = '未設定';

export const CURRENT_LOCATION_TEXT = '対象地域';
export const AUTHOR_TEXT = '送信者';
export const LIVING_LOCATION_TEXT = '居住地';

export const URL_TEXT = '詳細画面URL';

export const IS_DEBUG_TEXT = 'テスト通知';
export const IS_DEBUG_ON_TEXT = 'ON';
export const IS_DEBUG_OFF_TEXT = 'OFF';
export const IS_DEBUG_ALL_TEXT = 'すべての通知';
export const IS_DEBUG_ONLY_TEXT = 'テスト通知のみ';
export const IS_DEBUG_NOT_TEXT = 'テスト通知を除く';
export const IS_DEBUG_ON_CODE = 1;
export const IS_DEBUG_OFF_CODE = 0;

export const NOTIFICATION_TYPE_TEXT = '送信種別';
export const NOTIFICATION_TYPE_ALL_TEXT = 'すべての種別';
export const NOTIFICATION_TYPE_1_TEXT = '地域の安全情報';
export const NOTIFICATION_TYPE_2_TEXT = '徘徊・行方不明情報';
export const NOTIFICATION_TYPE_3_TEXT = '透析医療機関の被災状況';
export const NOTIFICATION_TYPE_4_TEXT = 'その他';
export const NOTIFICATION_TYPE_5_TEXT = '県からの注意喚起';
export const NOTIFICATION_TYPE_1_CODE = 1;
export const NOTIFICATION_TYPE_2_CODE = 2;
export const NOTIFICATION_TYPE_3_CODE = 3;
export const NOTIFICATION_TYPE_4_CODE = 4;
export const NOTIFICATION_TYPE_5_CODE = 5;

export const PUSH_LOG_INDEX_TEXT = '通知履歴一覧';
export const PUSH_LOG_DETAIL_TEXT = '通知履歴';
export const PUSH_INPUT_FORM_TEXT = '通知内容入力';
export const PUSH_INPUT_CONFIRM_TEXT = '通知内容確認';

export const SEND_STATUS_TEXT = '送信状況';
export const SEND_DATETIME_TEXT = '送信日時';
export const SEND_SUCCEED_TEXT = '成功件数';
export const SEND_FAILED_TEXT = '失敗件数';
export const BACK_TO_INDEX_TEXT = '一覧に戻る';
export const DELETE_LOG_TEXT = '履歴を削除する';
export const REUSE_LOG_TEXT = '再利用する';

export const FILE_LIST_INDEX_TEXT = 'アップロードファイル一覧';
export const FILE_NAME_TEXT = 'ファイル名';
export const FILE_DATETIME_TEXT = 'アップロード日時';
export const FILE_SPACE_TEXT = ' ';
export const NOTIFICATION = '通知';
export const DELETE = '削除';
export const UPLOAD = '送信';

export const SENDCOMPLETION = '送信完了';
export const SENDPROCESSING = '送信処理中';
// #endregion
